<template>
  <div class="LKPublicationsList">
    <LkSearchInput
      v-model="filters.search"
      :loading="isLoading && !isLoadingAsyncData"
      placeholder="Поиск по названию"
      @submit="onChangeFilter(filters)"
    />

    <LKProgressCircular
      v-if="isLoadingAsyncData"
      overlay
      :size="50"
      style="align-items: start; padding-top: 30vh;"
    />

    <LKPublicationsCardList
      v-else-if="list && list.length"
      :list="list"
      :loading="isLoading"
      :pagination="pagination"
      :topic-slug="topic_slug"
      :get-publication="getOneBySlug"
      @change:next-page="onChangeNextPage"
    />

    <div
      v-else-if="errorMessage"
      class="LKPublicationsList__error-message"
      v-text="errorMessage"
    />

    <h4
      v-else
      class="LKPublicationsList__no-items-message"
      v-text="'Список пуст'"
    />
  </div>
</template>

<script>
/* eslint-disable import/no-unresolved, import/extensions */
/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

import { createListMixin } from '@/helpers/mixins/createListMixin'
import { getErrorMessages } from '@/helpers/getErrorMessages'
import { LkTopicPublicationModel as Model } from './Model'
import { lkPublicationsMapper as StoreMapper, lkPublicationsStoreModule as StoreModule } from './store'
import { lkMapper } from '@/store/modules/lk'

import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import LkSearchInput from '@/components/lk/LkSearchInput.vue'
import LKPublicationsCardList from './components/LKPublicationsCardList.vue'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

export default {
  name: 'LKPublicationsList',
  components: {
    LKProgressCircular,
    LkSearchInput,
    LKPublicationsCardList,
  },
  mixins: [listMixin],
  props: {
    topic_slug: {
      type: String,
      required: true,
    },
  },
  data: (vm) => ({
    errorMessage: null,
    disabledPaginationQuery: true,
    defaultParams: {
      topic_slug: vm.topic_slug,
    },
  }),
  computed: {
    filters() {
      const { filters } = this.storeModule.state
      const page = filters.topic_slug === this.topic_slug ? filters.page : 1
      return { ...filters, page }
    },
  },
  watch: {
    topic_slug(value) {
      this.defaultParams = {
        topic_slug: value,
      }
      this.onChangeTopicSlug()
    },
  },
  async created() {
    await this.refreshBanners()
  },
  activated() {
    this.list
      ?.filter((_) => 'data_collections' in _)
      .forEach(this.getOneBySlug)
  },
  methods: {
    ...lkMapper.mapActions(['getBanners']),
    ...StoreMapper.mapMutations(['setList']),
    ...StoreMapper.mapActions(['getOneBySlug']),

    async refreshBanners() {
      await new Promise((resolve) => this.$router.onReady(resolve))
      const { topic_slug } = this.$route.params
      return this.getBanners({ slug: topic_slug })
    },
    async onChangeTopicSlug() {
      this.errorMessage = null
      const promise = this.asyncData()
      this.setList([])

      try {
        await promise
        await this.refreshBanners()
      } catch (e) {
        this.errorMessage = getErrorMessages(e).join(', ')
      }
    },
  },
}
</script>

<style lang="scss">
@import "~@/assets/scss/components/LKPublicationsList/_LKPublicationsList.scss";

.LKPublicationsList {
  @include _LKPublicationsList;
}
</style>
